import { React } from 'react';

import HeaderMain from "../../components/headerMain/HeaderMain.jsx"
import SliderCover from './SliderCover.jsx';
import Mission from './Mission.jsx';
import Advantages from '../../pages/mainPage/Advantages.jsx'
import ActionCpc from './ActionCpc.jsx';
import Galery from './Galery.jsx';
import Reviews from '../../pages/mainPage/Reviews.jsx';
import Partners from '../../pages/mainPage/Partners.jsx';
import News from './News.jsx';
import HomeReviewsSlider from './HomeReviewSlider.jsx';
import Footer from '../../components/footer/Footer.jsx';
import { positions } from '@mui/system';
import PopupPrivacy from '../../components/popupPrivacy/PopupPrivacy.jsx';
import { Link } from 'react-router-dom';

import "./MainPage.css"

export function MainPage() {
  const bgColor = '#58a0dc';

  return (
    <div>
      <HeaderMain />
      <PopupPrivacy />
      <SliderCover />
      {/* миссия */}
      <Mission />
      {/* о деятельности текстом и видео рядом */}
      <ActionCpc bgColor={bgColor}/>
      {/* галерея */}
      <Galery />
      {/* преимущества обучения */}
      <Advantages bgColor={bgColor}/>
      {/* отзывы - теперь здесь слайдер! */}
      <div id="reviews">
        <HomeReviewsSlider bgColor={bgColor}/>
      </div>
      {/* Наши партнеры */}
      <Partners />
      {/* Новости */}
      <News bgColor={bgColor}/>
      
      <Footer />
    </div>
  );
}